import React, { useState } from "react";
import barcode1 from "./assets/barcode1.webp";
import barcode2 from "./assets/barcode2.webp";
import upiLogo from "./assets/upiLogo.jpeg";

const Qrcodes = () => {
  const [copiedText, setCopiedText] = useState(null);

  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      }
    } catch (error) {
      console.error("Copy failed", error);
    }
  };

  return (
    <div className="px-4 md:px-10 py-12 bg-gray-50">
      {/* Donation Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Bank Block */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
          <h3 className="bg-[#C61D21] text-white text-center py-3 font-semibold text-lg">
            Donation Through Bank (NEFT/RTGS)
          </h3>
          <div className="p-5 space-y-3 text-gray-700 text-sm md:text-base">
            {[
              { label: "Bank Name", value: "HDFC Bank", id: "bankName" },
              { label: "Account Name", value: "ISKCON", id: "accountName" },
              { label: "Account Number", value: "50100436709020", id: "accountNumber" },
              { label: "IFSC Code", value: "HDFC000568", id: "ifscCode" },
            ].map((item) => (
              <div key={item.id} className="flex justify-between items-center">
                <span>
                  <span className="font-semibold">{item.label}:</span>{" "}
                  {item.value}
                </span>
                <button
                  className={`px-2 py-1 text-xs rounded-md transition ${
                    copiedText === item.id
                      ? "bg-green-100 text-green-600"
                      : "bg-gray-100 hover:bg-[#C61D21] hover:text-white"
                  }`}
                  onClick={() => copyToClipboard(item.value, item.id)}
                >
                  {copiedText === item.id ? "✔ Copied" : "Copy"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Paytm Block */}
        {/* <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
          <h3 className="bg-[#C61D21] text-white text-center py-3 font-semibold text-lg">
            Donate using Paytm
          </h3>
          <div className="p-6 flex flex-col items-center gap-4">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6a/Paytm_logo.png"
              alt="Paytm"
              className="h-10"
            />
            <p className="text-sm text-gray-700">
              Link:{" "}
              <span className="text-blue-600 underline">
                https://paytm.me/Onr-Zsr
              </span>
              <button
                className={`ml-2 px-2 py-1 text-xs rounded-md transition ${
                  copiedText === "paytm"
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 hover:bg-[#C61D21] hover:text-white"
                }`}
                onClick={() => copyToClipboard("https://paytm.me/Onr-Zsr", "paytm")}
              >
                {copiedText === "paytm" ? "✔ Copied" : "Copy"}
              </button>
            </p>
            <a
              href="https://paytm.me/Onr-Zsr"
              target="_blank"
              rel="noreferrer"
              className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-blue-600 transition"
            >
              DONATE NOW
            </a>
          </div>
        </div> */}

        {/* UPI Block */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
          <h3 className="bg-[#C61D21] text-white text-center py-3 font-semibold text-lg">
            Donate through UPI
          </h3>
          <div className="p-6 flex flex-col items-center gap-4">
            <span className="flex items-center gap-2">
              <img src={upiLogo} alt="UPI" className="h-8" />
              <span className="font-medium">ISKCON</span>
            </span>
            <p className="text-sm text-gray-700 flex items-center gap-2">
              <span className="font-semibold">UPI ID:</span>{" "}
              iskconvijayawada@idfcbank
              <button
                className={`ml-2 px-2 py-1 text-xs rounded-md transition ${
                  copiedText === "upi"
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 hover:bg-[#C61D21] hover:text-white"
                }`}
                onClick={() =>
                  copyToClipboard("iskconvijayawada@idfcbank", "upi")
                }
              >
                {copiedText === "upi" ? "✔ Copied" : "Copy"}
              </button>
            </p>
            <div className="flex gap-4">
              <img
                src={barcode1}
                alt="QR Code 1"
                className="w-28 h-28 border rounded-md"
              />
              <img
                src={barcode2}
                alt="QR Code 2"
                className="w-28 h-28 border rounded-md"
              />
            </div>
            <p className="text-xs text-gray-500 text-center">
              (Use Google Pay, PhonePe, Paytm, BHIM & other UPI apps)
            </p>
          </div>
        </div>
      </div>

      {/* After Donation Info */}
      <div className="mt-10 bg-gray-100 border rounded-lg p-6 text-center text-gray-700 text-sm md:text-base">
        Gentle Request! While donating via Bank/Paytm/UPI, please send us a
        screenshot along with your address & PAN details on WhatsApp{" "}
        <span className="font-semibold text-[#C61D21]">+91 9955685568</span> or
        email us at{" "}
        <span className="font-semibold text-blue-600">
          support@iskconvijayawada.org
        </span>
        . You may also call us on this number for queries.
      </div>
    </div>
  );
};

export default Qrcodes;
